<template>
  <div>
    <v-navigation-drawer
      hide-overlay
      fixed
      absolute
      :temporary="$vuetify.breakpoint.xsOnly"
      style="position: fixed; z-index: 10; min-height: 100vh"
      class="drawer"
      v-model="drawer"
      app
      width="250"
      clipped
    >
      <template v-slot:prepend>
        <div>
          <div>
            <v-list-item class="text-center">
              <v-list-item-icon>
                <img
                  @click="openHome"
                  :src="covesto_logo"
                  alt=""
                  class="logo"
                />
              </v-list-item-icon>
            </v-list-item>
          </div>
          <div class="admin__text text-center">Admin</div>
          <v-divider class="mb-5"></v-divider>
        </div>
      </template>

      <v-list nav class="px-0 py-0">
        <v-list-item-group v-model="selectedItem">
          <div v-for="(route, i) in items" :key="i">
            <v-list-item
              class="my-0 mt-0"
              link
              :to="{ name: route.pathName }"
              active-class="active-page"
            >
              <v-list-item-icon>
                <v-icon size="25" class="nav-icon pl-5">{{
                  route.icon
                }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title class="item-title">{{
                  route.title
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </div>
        </v-list-item-group>
      </v-list>
      <template v-slot:append>
        <div class="pa-2">
          <v-list-item link @click="logout" class="pl-5">
            <v-icon class="mr-2">mdi-logout</v-icon>
            <span class="pl-4 item-title">Logout</span>
          </v-list-item>
        </div>
        <div
          style="border-top: 1px solid rgba(0, 0, 0, 0.12)"
          class="nav-foot mb-2 mt-2"
        >
          <div class="playStore d-flex align-center justify-center">
            <img :src="playStore" alt="" @click="gotoSocialMedia('playsore')" />
          </div>
          <p class="text-center">Follow us on</p>
          <div class="social-media-images d-flex align-center justify-center">
            <img :src="telegram" alt="" @click="gotoSocialMedia('telegram')" />
            <img :src="linkedin" alt="" @click="gotoSocialMedia('linkedin')" />
            <img
              :src="instagram"
              alt=""
              style="object-fit: cover; height: 35px"
              @click="gotoSocialMedia('instagram')"
            />
            <img :src="facebook" alt="" @click="gotoSocialMedia('facebook')" />
          </div>
        </div>
      </template>
    </v-navigation-drawer>
    <v-app-bar app color="#fff" elevation="1" clipped-right>
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        v-if="!drawer"
      ></v-app-bar-nav-icon>

      <v-toolbar-title>
        <img
          :src="covesto_logo"
          class="covesto___logo__mobile"
          @click="openHome"
        />
      </v-toolbar-title>
      <v-spacer> </v-spacer>
      <v-btn
        elevation="0"
        class="notification-btn"
        style="letter-spacing: 0px; text-transform: capitalize"
        @click="goToPublicPage"
        dense
        color="#F2F8FF"
      >
        <!-- <v-icon color="#333333"> mdi-bell-outline </v-icon> -->
        Goto Public Page
      </v-btn>
    </v-app-bar>
    <v-main class="fill-height">
      <div class="px-7 py-7">
        <router-view :key="$route.path"></router-view>
      </div>
      <bonusCreditModal></bonusCreditModal>
    </v-main>
  </div>
</template>
<script>
import bonusCreditModal from "@/components/gamification/bonusCreditsModal.vue";
import ROUTER_URL from "@/constant/urls";
import authToken from "@/common/authToken";
export default {
  name: "AdminLayout",
  components: { bonusCreditModal },

  data() {
    return {
      loading: false,
      selectedItem: 0,
      items: [
        {
          pathName: ROUTER_URL.adminPanel.children.group.name,
          title: "Bank Info",
          icon: "mdi-badge-account-outline",
        },
        {
          pathName: ROUTER_URL.adminPanel.children.videoCourses.name,
          title: "Videos",
          icon: "mdi-file-video-outline",
        },
        {
          pathName: ROUTER_URL.adminPanel.children.teams.name,
          title: "Admin",
          icon: "mdi-account-group-outline",
        },
        // {
        //   pathName: "NetworkPage",
        //   title: "Network",
        //   icon: "mdi-account-group-outline",
        // },
        // {
        //   pathName: "membership",
        //   title: "My Memberships",
        //   icon: "mdi-crown-outline",
        // },
        // {
        //   pathName: "transaction",
        //   title: "Accounts",
        //   icon: "mdi-receipt-text-outline",
        // },
      ],
      covesto_logo: require("@/assets/Logo.svg"),
      telegram: require("@/assets/images/telegram.svg"),
      linkedin: require("@/assets/images/linkedin.svg"),
      instagram: require("@/assets/images/instagram.svg"),
      facebook: require("@/assets/images/facebook.svg"),
      playStore: require("@/assets/google-play-badge.png"),
      drawer: true,
    };
  },
  computed: {},
  watch: {},
  methods: {
    openHome() {
      //   const user_id = localStorage.getItem("user_id");
      this.$router.push({ name: ROUTER_URL.adminPanel.children.group.name });
    },
    logout() {
      authToken.logout();
    },
    goToPublicPage() {
      this.$router.push({
        name: "mainPage",
      });
    },
  },
  mounted() {},
};
</script>
<style>
.col {
  padding: 0px 0px !important;
}
.pointer {
  cursor: pointer;
}
.admin__text {
  font-family: "Avenir";
  font-style: normal;
  font-weight: 900;
  font-size: 19px;
  line-height: 26px;
  /* identical to box height */

  color: #1a1b41;
}
</style>
<style lang="scss" scoped>
@font-face {
  font-family: "Avenir";
  src: url(../../assets/fonts/AvenirRegular/AvenirRegular.ttf)
    format("TrueType");
  letter-spacing: 0px;
}
*,
#public-section {
  font-family: "Avenir";
}

.drawer {
  box-shadow: 0px 1px 8px rgba(34, 123, 232, 0.14);
  border-radius: 8px;
  top: 0px !important;
  bottom: 0px !important;
  margin: 0px !important;
  padding: 0px !important;
}
.main-container {
  display: flex;
}

.logo {
  width: 170px;
  height: 50px;
  margin-left: 14px;
  margin-top: 20px;
  cursor: pointer;
}

.right-container {
  display: flex;
  flex-direction: column;
}
.item-title {
  font-size: 18px !important;
}

.social-media-images {
  text-align: center;
  padding-bottom: 20px;

  p {
    color: rgba(51, 51, 51, 0.87);
  }
}
.notification-mobile {
  display: none;
}
.notification-desktop {
  display: block;
}

.nav__text {
  display: none !important;
}
.covesto___logo__mobile {
  display: block !important;
  height: 40px;
  cursor: pointer;
  margin: auto 30px !important;
  width: 100%;
}
.active-page {
  background: #2d8cff;

  .item-title {
    color: white;
  }

  .nav-icon {
    color: white !important;
  }
}

.social-media-images img {
  width: 30px;
  height: 30px;
  margin: 0 7px;
  cursor: pointer;
}
.playStore img {
  width: 200px;
  height: 80px;
  margin: 0 7px;
  cursor: pointer;
}

.drawer {
  display: flex;
}
@media all and (max-width: 600px) {
  .nav__text {
    display: none !important;
  }
  .nav-foot {
    margin-bottom: 100px !important;
  }
  .notification-mobile {
    display: inline;
    padding: 5px;
  }
  .notification-desktop {
    display: none;
  }
}

.notification-btn {
  border: 0.5px solid rgba(51, 51, 51, 0.08);
  box-sizing: border-box;
  border-radius: 8px;
}
.notification-btn {
  border: 0.5px solid rgba(51, 51, 51, 0.08);
  box-sizing: border-box;
  border-radius: 8px;
}
@media all and (min-width: 1000px) {
  .nav__text {
    padding-left: 20px;
    display: inline !important;
  }
}
.covesto___logo__mobile {
  display: none !important;
}
</style>
